import React, { Component } from "react";
import { observer } from "mobx-react";
import { select_addr_forkakao_pos } from "../../http/kakaoConn";
import { fn_search_address_deail_box_show } from "../../function/FnBodyLayer";
import AddressSearchStore from "../../stores/AddressSearchStore";
import SearchStore from "../../stores/SearchStore";
import SettingStore from "../../stores/SettingStore";
import LayerStore from "../../stores/LayerStore";
import ViewStore from "../../stores/ViewStore";
import { fn_bridge_close, fn_bridge_load_shop, fn_send_address_pos } from "../../function/FnPosBridge";
import { select_quick_addr } from "../../http/SettingConn";
import { select_access_token } from "../../http/TokenConn";
import { fn_address_api_pos } from "function/FnBodyStep";
import AddressSearchKakaoMap from "../../utils/AddressSearchKakaoMap";
import AddressSearchNaverMap from "../../utils/AddressSearchNaverMap";
import AddressSearchForPosViewItem from "./item/AddressSearchForPosViewItem";
import { aesDecoding } from "../../utils/Utils";

@observer
class AddressSearchForPosView extends Component {
    constructor(props) {
        super(props);
        this.rootStore = {
            layerStore: LayerStore,
            searchStore: SearchStore,
            settingStore: SettingStore,
            addressSearchStore: AddressSearchStore,
            viewStore: ViewStore
        }
        fn_bridge_load_shop(this.rootStore).then(load_yn => {
            select_access_token(this.rootStore).then(res => {
                select_quick_addr(this.rootStore);
            });
        })
        this.state = { addressScroll: 0, keywordScroll: 0 }

        this.inputFocus = React.createRef();
        this.inputDetailFocus = React.createRef();
        this.focusStatus = false;
    }
    setFocusTextBox = (e) => {
        this.inputFocus.current.focus();
    }

    setFocusDetailTextBox = (e) => {
        this.inputDetailFocus.current.focus();
    }
    searchKeyPress = (e) => {
        if (e.key === "Enter") {
            //select_addr_forkakao_pos(this.rootStore)
            fn_address_api_pos(this.rootStore, "kakao")
        }
    };

    inputBoxDel = (e) => {
        const { rootStore } = this;
        fn_search_address_deail_box_show(rootStore, false);
        rootStore.addressSearchStore.setDetailSearchAddrDetail("");  // 주소 상세 검색란 초기화
        rootStore.addressSearchStore.setDetailSearchAddr("");
        rootStore.addressSearchStore.setKakaoMap("", "");
        rootStore.addressSearchStore.initSearchAddrList();
        document.getElementById("addAdressPos").value = ""
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        let addressArea = document.getElementById("addressListElement")
        addressArea.scrollTop = this.state.addressScroll;
        let keywordArea = document.getElementById("keywordListElement")
        keywordArea.scrollTop = this.state.keywordScroll;
        if (this.focusStatus == true) {
            this.setFocusDetailTextBox();
        } else {
            this.setFocusTextBox()
        }
    }

    addressScrollSet = (val) => {
        this.setState({ addressScroll: val })
    }

    addressScrollUp = () => {
        if (this.state.addressScroll >= 57)
            this.setState({ addressScroll: this.state.addressScroll - 57 })
    }

    addressScrollDown = () => {
        if (this.state.addressScroll + 289 < document.getElementById("addressListElement").scrollHeight)
            this.setState({ addressScroll: this.state.addressScroll + 57 })
    }

    keywordScrollUp = () => {
        if (this.state.keywordScroll >= 52)
            this.setState({ keywordScroll: this.state.keywordScroll - 52 })
    }

    keywordScrollDown = () => {
        if (this.state.keywordScroll + 98 < document.getElementById("keywordListElement").scrollHeight)
            this.setState({ keywordScroll: this.state.keywordScroll + 52 })
    }

    layerClose = () => {
        const { rootStore } = this;
        this.setState({ addressScroll: 0, keywordScroll: 0 });
        rootStore.layerStore.setLayerAddressSearch(false);
        document.getElementById("addAdressPos").value = "";
    }

    nullBoxCreate = (count) => {
        let areaArr = [1, 2, 3, 4, 5, 6, 7, 8]
        areaArr = areaArr.slice(count)
        let nullBox = areaArr.map((value) => {
            return <li key={value}><button disabled={true}></button></li>
        }
        );
        return nullBox
    }

    render() {

        const { rootStore } = this;
        rootStore.layerStore.setLayerLoadingView(false)
        let quickAddrLength = rootStore.settingStore.getQuickAddr.length;

        global.fn_pos_address_search = function (address) {
            //초기화
            fn_search_address_deail_box_show(rootStore, false);
            rootStore.addressSearchStore.setDetailSearchAddrDetail("");  // 주소 상세 검색란 초기화
            rootStore.addressSearchStore.setDetailSearchAddr("");
            rootStore.addressSearchStore.setKakaoMap("", "")
            rootStore.addressSearchStore.initSearchAddrList();
            document.getElementById("addAdressPos").value = ""

            if (!(address == null || address == "null" || address.trim() == "")) {
                let searchAddress = aesDecoding(address);
                rootStore.addressSearchStore.setDetailSearchAddr(searchAddress)
            }

            return;
        }

        let searchMsg
        if (rootStore.addressSearchStore.getSearchAddrResult === "many") {
            searchMsg = <><div className="etc many"><p>검색팁을 참고하여 검색해주세요.</p></div></>
        } else if (rootStore.addressSearchStore.getSearchAddrResult === "ok") {
            searchMsg = ""
        } else {
            searchMsg = <><div className="etc empty"><p>검색팁을 참고하여 검색해주세요.</p></div></>
        }
        return (
            <div className="layer_comm layer_address_search layer_open">
                <div className="layer_content">
                    <div className="article_address_search">
                        <h1 className="section_tit">
                            <strong className="tit">주소검색</strong>
                            <span className="txt">
                                <em>자주쓰는 주소 키워드</em> 또는 <em>검색어 입력</em>으로 주소를 찾을 수 있습니다.
                            </span>
                        </h1>
                        <div className="clear_g">
                            <div className="section_left">
                                <div className="wrap_tit">
                                    <h2>자주 쓰는 주소 키워드</h2>
                                    <p>※ 키워드 등록/삭제 : [설정 &gt; 주소검색 설정] </p>
                                </div>
                                <div className="wrap_keyword">
                                    <div className="scroll scroll_hidden" id="keywordListElement">
                                        <ul className="list">
                                            {
                                                (Array.isArray(rootStore.settingStore.getQuickAddr) && rootStore.settingStore.getQuickAddr.length)
                                                    ?
                                                    rootStore.settingStore.getQuickAddr.map((obj, index) => (
                                                        <li key={"keyAddr" + index}
                                                            onClick={event => {
                                                                fn_search_address_deail_box_show(rootStore, false);
                                                                rootStore.addressSearchStore.setDetailNowSearchAddr(rootStore, obj.addr);
                                                                document.getElementById("addAdressPos").value = "";
                                                                this.focusStatus = true;
                                                            }}
                                                        >
                                                            <button>{obj.addr}</button>
                                                        </li>
                                                    ))
                                                    :
                                                    null
                                            }
                                            {this.nullBoxCreate(quickAddrLength)}
                                        </ul>
                                    </div>
                                    <div className="btns">
                                        <button type="button" className="btn_up" onClick={this.keywordScrollUp}><span></span></button>
                                        <button type="button" className="btn_down" onClick={this.keywordScrollDown}><span></span></button>
                                    </div>
                                </div>
                                <div className="wrap_tit">
                                    <h2>주소 검색어 입력</h2>
                                    <div>
                                        <span className="ico_tip"></span>
                                        <span>도로명 + 건물번호, 동/읍/면/리 + 번지, 지역명 + 건물명</span>
                                    </div>
                                </div>
                                <div className="wrap_search">
                                    <input type="text" id="searchTxt" ref={this.inputFocus} placeholder="예) 판교역로 235, 삼성동 154-8" value={(rootStore.addressSearchStore.getDetailSearchAddr != null) ? rootStore.addressSearchStore.getDetailSearchAddr : ""} onKeyPress={this.searchKeyPress}
                                        onChange={event => rootStore.addressSearchStore.setDetailSearchAddr(event.target.value)} autoFocus={true} onFocus={() => {
                                            this.focusStatus = false;
                                        }}
                                    />
                                    <button type="button" className="btn_clear" onClick={this.inputBoxDel}><span
                                        className="screen_out">입력값 삭제</span></button>
                                    <button type="submit" id="searchInput"
                                        onClick={event => {
                                            fn_search_address_deail_box_show(rootStore, false);
                                            //select_addr_forkakao_pos(rootStore);
                                            fn_address_api_pos(rootStore, "kakao");
                                            document.getElementById("addAdressPos").value = "";
                                        }
                                        }
                                    >검색</button>
                                </div>
                                <div className="wrap_tit">
                                    <h2>주소 목록 <span>(검색결과 <em>{(rootStore.addressSearchStore.getSearchAddrCount > 0) ? rootStore.addressSearchStore.getSearchAddrCount : rootStore.addressSearchStore.getSearchAddrList.length}건</em>)</span></h2>
                                </div>
                                <div className="wrap_address_list">
                                    <div className="scroll scroll_hidden" id="addressListElement">
                                        {searchMsg}
                                        <ul className="list"
                                            // onClick={()=>{this.setFocusDetailTextBox;this.focusStatus = true}}
                                            onClick={() => {
                                                //document.getElementById("addAdressPos").value = ""; 
                                                this.focusStatus = true
                                            }}
                                        >
                                            {
                                                (Array.isArray(rootStore.addressSearchStore.getSearchAddrList) && rootStore.addressSearchStore.getSearchAddrList.length)
                                                    ?
                                                    rootStore.addressSearchStore.getSearchAddrList.map((addr, index) => (
                                                        <AddressSearchForPosViewItem key={"orderAddr" + index} rootStore={rootStore} addr={addr} addressScrollSet={this.addressScrollSet} />
                                                    ))
                                                    :
                                                    null
                                            }
                                        </ul>

                                    </div>
                                    <div className="btns">
                                        <button type="button" className="btn_up" onClick={this.addressScrollUp}><span></span></button>
                                        <button type="button" className="btn_down" onClick={this.addressScrollDown}><span></span></button>
                                    </div>
                                </div>
                            </div>
                            <div className="section_right">
                                <div className="wrap_address_detail">
                                    <h3>상세주소 입력</h3>
                                    {
                                        (rootStore.addressSearchStore.getAddrApiName.api === "kakao")
                                            ? <AddressSearchKakaoMap rootStore={this.rootStore} />
                                            : <AddressSearchNaverMap rootStore={this.rootStore} />
                                    }
                                    {

                                    }
                                    <div className="box_txt">
                                        {
                                            (rootStore.addressSearchStore.getAddrBoxShowFlag)
                                                ?
                                                <div className="inner">
                                                    <h4>{rootStore.addressSearchStore.getSelectRoadAddrVal ?
                                                        rootStore.addressSearchStore.getSelectAddrVal : rootStore.addressSearchStore.getClickedPosAddress}
                                                    </h4>
                                                    {/* {rootStore.addressSearchStore.getDetailSearchAddrDetail} */}
                                                    <p>(도로명) {rootStore.addressSearchStore.getSelectRoadAddrVal || ""}</p>
                                                </div>
                                                : <div className="inner disabled"></div>
                                        }
                                    </div>
                                    <div className="box_inp">
                                        <input type="text" id="addAdressPos" ref={this.inputDetailFocus} placeholder="상세주소 입력" maxLength={30}
                                            onChange={event => event.target.value}
                                            disabled={(rootStore.addressSearchStore.getAddrBoxShowFlag) ? false : true}
                                        //    onBlur={()=>{this.focusStatus = false}}
                                        />
                                    </div>
                                    <div className="box_btn">
                                        {
                                            (rootStore.addressSearchStore.getAddrBoxShowFlag) ?
                                                <button id="btn"
                                                    onClick={event => {
                                                        fn_send_address_pos(rootStore, document.getElementById("addAdressPos").value);
                                                        document.getElementById("addAdressPos").value = "";
                                                        this.focusStatus = false
                                                    }}
                                                >
                                                    <span>주소지 설정</span>
                                                </button>
                                                :
                                                <button id="btn"><span>주소지 설정</span></button>
                                        }

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="btn_close">
                            <button
                                onClick={() => {
                                    this.focusStatus = false
                                    this.layerClose();
                                }}
                            ><span>닫기</span></button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AddressSearchForPosView;